export enum TaxDisplayMode {
  NoTax = 0,
  SilentAdd = 1,
  AddAndShow = 2,
  AddAtInvoice = 3,
}
